import React, { useEffect, useState } from 'react';
export function StickyTopBar() {
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-purple text-white py-3 px-4 shadow-md" data-id="element-219">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-220">
        <span data-id="element-221">Oferta especial activa</span>
        <span className="hidden sm:inline" data-id="element-222">·</span>
        <div className="bg-brand-yellow text-brand-purpleDark px-3 py-1 rounded-md font-bold flex items-center gap-1" data-id="element-223">
          <span data-id="element-224">⏱</span> {timeString}
        </div>
        <span className="hidden sm:inline" data-id="element-225">·</span>
        <div className="flex items-center gap-2" data-id="element-226">
          <span className="line-through opacity-70" data-id="element-227">$30.000</span>
          <span className="text-brand-yellow font-bold" data-id="element-228">$6.999 ARS</span>
        </div>
      </div>
    </div>;
}